var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { generateImageProcessorParamsWithWidthAndHeight } from "@react-components/primitives/UmbracoImage/imageProcessor/generateImageProcessorParamsWithWidthAndHeight";
export var serializeQueryParameters = function (src, params) {
    return Object.entries(params).reduce(function (url, _a, index) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return index === 0 ? url + "?" + key + "=" + value : url + "&" + key + "=" + value;
    }, "" + src);
};
export var generateImageSources = function (image, resolutions, breakpoints, width, height) {
    var mappableSources = [];
    if (!Array.isArray(width) && !Array.isArray(height)) {
        var srcSet_1 = [];
        var mappableSource_1 = {
            srcSet: "",
            urlParams: {},
        };
        resolutions.forEach(function (resolution) {
            var mappableProps = generateImageProcessorParamsWithWidthAndHeight(resolution, 0, width, height, image === null || image === void 0 ? void 0 : image.focalPoint);
            srcSet_1.push(serializeQueryParameters(image.url, mappableProps) + " " + resolution + "x");
            mappableSource_1.urlParams[resolution] = mappableProps;
        });
        mappableSource_1.srcSet = __spreadArray([], __read(srcSet_1), false).join(",");
        mappableSources.push(mappableSource_1);
        return mappableSources;
    }
    Object.values(breakpoints).forEach(function (breakpoint, breakpointIndex) {
        if ((Array.isArray(width) &&
            (width[breakpointIndex] === null || !width[breakpointIndex])) ||
            (Array.isArray(height) &&
                (height[breakpointIndex] === null || !height[breakpointIndex]))) {
            return;
        }
        var srcSet = [];
        var mappableSource = {
            media: "",
            srcSet: "",
            urlParams: {},
        };
        mappableSource.media = "(min-width: " + breakpoint + "px)";
        resolutions.forEach(function (resolution) {
            var mappableProps = generateImageProcessorParamsWithWidthAndHeight(breakpointIndex, resolution, width, height, image === null || image === void 0 ? void 0 : image.focalPoint);
            srcSet.push(serializeQueryParameters(image.url, mappableProps) + " " + resolution + "x");
            mappableSource.urlParams[resolution] = mappableProps;
        });
        mappableSource.srcSet = __spreadArray([], __read(srcSet), false).join(",");
        mappableSources.push(mappableSource);
    });
    return mappableSources;
};
